import { Action, createReducer, on } from '@ngrx/store';
import { RequirementOverrideDetail } from '../../models/requirement-override-detail.model';
import { RequirementOverrideState } from '../state/requirement-override.state';
import * as actions from 'src/app/compliance/store/actions/requirement-override.actions';

const initialState: RequirementOverrideState = {
    details: {} as RequirementOverrideDetail,
    error: undefined,
    isLoading: false
};

const reducer = createReducer(
    initialState,
    on(actions.loadRequirementOverrideDetailsSuccessfully, (state, action) => ({
        ...state,
        details: action.details
    })),
    on(actions.setRequirementOverrideIsLoadingFlag, (state, action) => ({
        ...state,
        isLoading: action.isLoading
    })),
    on(actions.loadRequirementOverrideDetailsFailure, (state, action) => ({
        ...state,
        error: JSON.stringify(action.error)
    })),
    on(actions.saveRequirementsQualificationSettingsOverride, (state) => ({
        ...state,
        error: undefined
    })),
    on(actions.saveRequirementsQualificationSettingsOverrideSuccessfully, (state, { details }) => ({
        ...state,
        details: details as unknown as RequirementOverrideDetail,
        error: undefined
    })),
    on(actions.saveRequirementsQualificationSettingsOverrideFailure, (state, { error }) => ({
        ...state,
        error: JSON.stringify(error),
        isLoading: false
    })),
    on(actions.deleteRequirementQualificationSettingsOverride, (state) => ({
        ...state,
        error: undefined
    })),
    on(actions.deleteRequirementQualificationSettingsOverrideSuccessfully, (state, { details }) => ({
        ...state,
        details: details as unknown as RequirementOverrideDetail,
        error: undefined
    })),
    on(actions.deleteRequirementQualificationSettingsOverrideFailure, (state, { error }) => ({
        ...state,
        error: JSON.stringify(error),
        isLoading: false
    })),
    on(actions.saveRequirementsManualReviewOverride, (state) => ({
        ...state,
        error: undefined
    })),
    on(actions.saveRequirementsManualReviewOverrideSuccessfully, (state, { details }) => ({
        ...state,
        details: details as unknown as RequirementOverrideDetail,
        error: undefined
    })),
    on(actions.saveRequirementsManualReviewOverrideFailure, (state, { error }) => ({
        ...state,
        error: JSON.stringify(error),
        isLoading: false
    })),
    on(actions.deleteRequirementManualReviewOverride, (state) => ({
        ...state,
        error: undefined
    })),
    on(actions.deleteRequirementManualReviewOverrideSuccessfully, (state, { details }) => ({
        ...state,
        details: details as unknown as RequirementOverrideDetail,
        error: undefined
    })),
    on(actions.deleteRequirementManualReviewOverrideFailure, (state, { error }) => ({
        ...state,
        error: JSON.stringify(error),
        isLoading: false
    }))
);

export function requirementOverrideReducer(state: RequirementOverrideState | undefined, action: Action) {
    return reducer(state, action);
}
